import { PromoCodesForm } from 'components/promoCodes/PromoCodesForm/PromoCodesForm'

export const PromoCodesCreate: React.FC = () => {
  return <PromoCodesForm mode='create' />
}
